import React from "react";
import PropTypes from "prop-types";

const LinkArrow = ({
  className
}) => /*#__PURE__*/React.createElement("svg", {
  className: className,
  width: "10",
  height: "10",
  viewBox: "0 0 10 10",
  fill: "#438DED",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.33333 0V1.33333H7.72667L0 9.06L0.94 10L8.66667 2.27333V6.66667H10V0H3.33333Z"
}));

LinkArrow.propTypes = {
  className: PropTypes.string
};
export default LinkArrow;